<script lang="ts">
import { defineComponent } from 'vue'
export default defineComponent({
  name: 'setting',
})
</script>
<template>

    <a-list  item-layout="horizontal"   :dataSource="dataSource" :pagination="false">
      <template #renderItem="{item, index}">
      <a-list-item>
          <a-card :hoverable="true" style="width:100%">
            <div slot="title" class="text-bolder">{{ item.text }}</div>
            <div slot="extra" v-if="item.data" class="text-gray cuIcon-info ">{{ item.data }}</div>
            <a-card-meta>
              <template #description>
                <a-form>
                  <a-form-item v-for="(it, i) in item.child" :label="it.text" :key="i">
                    <a-input v-if="it.id == 1" v-model="it.pic" :place-holder="it.data" />
                    <a-textarea v-if="it.id == 2" rows="4" v-model="it.pic" :place-holder="it.data" />
                    <div slot="extra">{{ it.data }}</div>
                  </a-form-item>
                </a-form>
              </template>
            </a-card-meta>
          </a-card>
      </a-list-item>
      </template>
      <template #footer>
       <div class="text-center">
        <a-button type="primary" size="large" @click="add" >确 定</a-button></div>
     </template>
    </a-list>
</template>
<script setup lang="ts" name="setting">
import { onMounted ,ref} from 'vue'
import api from '@/utils/http/service'
const dataSource:Record<string, string>[] = ref([])
onMounted(()=>{
  getDataList()
})
const getDataList=():void=>{
  api.setting.list({}).then(res => {
        if (res.state == 1) {
          dataSource.value=res.data
          console.info('data',dataSource)
        }
      })
}
const add=():void=>{
  let ar = []
      dataSource.value.forEach(e => {
        e.child.forEach(f => {
          ar.push(f)
        })
      })
    api.setting.add(ar).then(res => {

      })
}
</script>
